import { Controller, useFormContext } from "react-hook-form";

import { useTranslation } from "@flare/i18n";
import {
  Input,
  Label,
  RadioCardItem,
  RadioCards,
  RadioCardTitle,
  Text,
} from "@flare/ui/components";

import { YOUR_CASE_QUESTIONS } from "../calculator.consts";
import { sendCalculatorAnswerBiEvent } from "../calculator.utils";

const {
  LEGAL_PAPERS,
  HAS_UPCOMING_COURT_EVENT,
  OWN_PROPERTY_TOGETHER,
  IS_LOOKING_TO_SETTLE,
} = YOUR_CASE_QUESTIONS;

export function CalculatorYourCase() {
  const { control } = useFormContext();

  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-sp-6">
      <Controller
        control={control}
        name="zipCode"
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-sp-2">
            <Label htmlFor="zipCode">
              {t("COST_CALCULATOR_ZIP_CODE_INPUT_LABEL")}
            </Label>
            <Input
              id="zipCode"
              type="text"
              placeholder={t("COST_CALCULATOR_ZIP_CODE_INPUT_PLACEHOLDER")}
              className="w-full rounded-lg"
              hasError={!!fieldState.error}
              {...field}
              onBlur={() => {
                sendCalculatorAnswerBiEvent({
                  key: "zipCode",
                  value: field.value,
                  text: t("COST_CALCULATOR_ZIP_CODE_INPUT_LABEL"),
                  type: "text",
                });
              }}
            />
            {fieldState.error && (
              <Text variant="caption" textColor="danger-highlight">
                {fieldState.error.message}
              </Text>
            )}
          </div>
        )}
      />

      <Controller
        name={LEGAL_PAPERS}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-sp-2">
            <Label htmlFor={LEGAL_PAPERS}>
              {t("COST_CALCULATOR_QUESTIONS_LEGAL_PAPERS")}
            </Label>
            <RadioCards
              defaultValue={field.value?.toString() || ""}
              onValueChange={(value) => {
                field.onChange(value);
                sendCalculatorAnswerBiEvent({
                  key: LEGAL_PAPERS,
                  value,
                  text: t("COST_CALCULATOR_QUESTIONS_LEGAL_PAPERS"),
                  type: "click",
                });
              }}
              className="flex gap-sp-3"
            >
              <RadioCardItem value="Yes">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_YES")}
                </RadioCardTitle>
              </RadioCardItem>
              <RadioCardItem value="No">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_NO")}
                </RadioCardTitle>
              </RadioCardItem>
            </RadioCards>
            {fieldState.error && (
              <Text variant="caption" textColor="danger-highlight">
                {fieldState.error.message}
              </Text>
            )}
          </div>
        )}
      />
      <Controller
        name={HAS_UPCOMING_COURT_EVENT}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-sp-2">
            <Label htmlFor={HAS_UPCOMING_COURT_EVENT}>
              {t("COST_CALCULATOR_QUESTIONS_HAS_UPCOMING_COURT_EVENT")}
            </Label>
            <RadioCards
              defaultValue={field.value?.toString() || ""}
              onValueChange={(value) => {
                field.onChange(value);
                sendCalculatorAnswerBiEvent({
                  key: HAS_UPCOMING_COURT_EVENT,
                  value,
                  text: t("COST_CALCULATOR_QUESTIONS_HAS_UPCOMING_COURT_EVENT"),
                  type: "click",
                });
              }}
              className="flex gap-sp-3"
            >
              <RadioCardItem value="true">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_YES")}
                </RadioCardTitle>
              </RadioCardItem>
              <RadioCardItem value="false">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_NO")}
                </RadioCardTitle>
              </RadioCardItem>
            </RadioCards>
            {fieldState.error && (
              <Text variant="caption" textColor="danger-highlight">
                {fieldState.error.message}
              </Text>
            )}
          </div>
        )}
      />
      <Controller
        name={OWN_PROPERTY_TOGETHER}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-sp-2">
            <Label htmlFor={OWN_PROPERTY_TOGETHER}>
              {t("COST_CALCULATOR_QUESTIONS_OWN_PROPERTY_TOGETHER")}
            </Label>
            <RadioCards
              defaultValue={field.value?.toString() || ""}
              onValueChange={(value) => {
                field.onChange(value);
                sendCalculatorAnswerBiEvent({
                  key: OWN_PROPERTY_TOGETHER,
                  value,
                  text: t("COST_CALCULATOR_QUESTIONS_OWN_PROPERTY_TOGETHER"),
                  type: "click",
                });
              }}
              className="flex gap-sp-3"
            >
              <RadioCardItem value="true">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_YES")}
                </RadioCardTitle>
              </RadioCardItem>
              <RadioCardItem value="false">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_NO")}
                </RadioCardTitle>
              </RadioCardItem>
            </RadioCards>
            {fieldState.error && (
              <Text variant="caption" textColor="danger-highlight">
                {fieldState.error.message}
              </Text>
            )}
          </div>
        )}
      />
      <Controller
        name={IS_LOOKING_TO_SETTLE}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-sp-2">
            <Label htmlFor={IS_LOOKING_TO_SETTLE}>
              {t("COST_CALCULATOR_QUESTIONS_IS_LOOKING_TO_SETTLE")}
            </Label>
            <RadioCards
              defaultValue={field.value?.toString() || ""}
              onValueChange={(value) => {
                field.onChange(value);
                sendCalculatorAnswerBiEvent({
                  key: IS_LOOKING_TO_SETTLE,
                  value,
                  text: t("COST_CALCULATOR_QUESTIONS_IS_LOOKING_TO_SETTLE"),
                  type: "click",
                });
              }}
              className="flex gap-sp-3"
            >
              <RadioCardItem value="true">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_YES")}
                </RadioCardTitle>
              </RadioCardItem>
              <RadioCardItem value="false">
                <RadioCardTitle>
                  {t("COST_CALCULATOR_QUESTION_LABEL_NO")}
                </RadioCardTitle>
              </RadioCardItem>
            </RadioCards>
            {fieldState.error && (
              <Text variant="caption" textColor="danger-highlight">
                {fieldState.error.message}
              </Text>
            )}
          </div>
        )}
      />
    </div>
  );
}
